import Icon, { IconName } from '@/components/Icon/Icon';
import { getTotalQty } from '@/components/SunrunShop/utils/quantity';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/zustand/hooks/useSunrunShopStore';
import { CartActions } from '@/data-store/zustand/slices/sunrunShopSlice';

import useStyles from './CartIcon.styles';

export default function CartIcon({ isOnDark }: { isOnDark: boolean }) {
  const { classes } = useStyles({ isOnDark });
  const { setIsCartOpen, setCartAction } = useSunrunShopActions();
  const { cart } = useSunrunShopStore('cart');
  const qty = getTotalQty(cart);

  const openCart = () => {
    setIsCartOpen(true);
    setCartAction(CartActions.VIEW_CART);
  };

  if (qty === 0) return null;
  return (
    // biome-ignore lint/a11y/useButtonType: Automated migration to Biome
    <button
      className={classes.button}
      onClick={openCart}
      aria-label={`Open Cart, ${qty} items inside`}
    >
      <div className={classes.qty}>{qty}</div>
      <Icon name={IconName.CART} />
    </button>
  );
}
